export const environment = {
  production: true,
  backendUrl: 'https://api-dev.bandbeat.com/v1' ,
  uploadUrl: 'https://api-dev.bandbeat.com/public/uploads/',
  reviewEnabled: true,
  paymentEnabled: true,
  promoCodesEnabled: true,
  contractsEnabled: true,
};
